import React from "react";
import SntIcon, { SntIconProps } from "./SntIcon";

const SntGlobeIcon: React.FC<SntIconProps> = (props) => {
  return (
    <SntIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 0C3.584 0 0 3.584 0 8C0 12.416 3.584 16 8 16C12.416 16 16 12.416 16 8C16 3.584 12.416 0 8 0ZM12.72 12.312C12.512 11.672 11.912 11.2 11.2 11.2H10.4V8.80001C10.4 8.36001 10.04 8.00001 9.6 8.00001H4.8V6.40001H6.4C6.84 6.40001 7.2 6.04001 7.2 5.60001V4.00001H8.8C9.68 4.00001 10.4 3.28001 10.4 2.40001V2.07201C12.744 3.01601 14.4 5.31201 14.4 8.00001C14.4 9.66401 13.76 11.176 12.72 12.312ZM1.6 7.99999C1.6 11.264 4.04 13.952 7.2 14.344V12.8C6.32 12.8 5.6 12.08 5.6 11.2V10.4L1.768 6.56799C1.664 7.02399 1.6 7.50399 1.6 7.99999Z"
      />
    </SntIcon>
  );
};

export default SntGlobeIcon;
